export default "__VITE_ASSET__mZLke$qq__"